import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #232332;
  min-height: 100vh;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
`;

export const Card = styled.div`
  background-color: #2f2f41;
  border-radius: 8px;
  padding: 20px;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

export const CardTitle = styled.h3`
  font-size: 15px;
  color: #ffd700; /* Amarelo para destaque */
  margin-bottom: 10px;
`;

export const CardSubtitle = styled.p`
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 20px;
`;

export const ChartContainer = styled.div`
  width: 100%;
  height: 200px;
`;

export const ListItem = styled.li`
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 5px;
`;

export const WelcomeMessage = styled.h2`
  font-size: 24px;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: left;
`;

export const CenteredNumber = styled.h1`
  font-size: 96px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
`;
